// Mock data for Wrangler Dubai Garage website

export const siteInfo = {
  name: "Wrangler Dubai Garage",
  tagline: "Import Wrangler Specialist",
  logoUrl: "https://customer-assets.emergentagent.com/job_wrangler-direct/artifacts/5myhj88j_WhatsApp%20Image%202026-01-29%20at%2020.42.21.jpeg",
  heroImageUrl: "https://customer-assets.emergentagent.com/job_wrangler-direct/artifacts/1j5tccg2_ChatGPT%20Image%2029%20ene%202026%2C%2013_10_58.png",
  email: "info@wranglerdubaigarage.com",
  phone: "+34 647 00 21 49",
  location: "Madrid, España",
  copyright: "© 2025 Wrangler Dubai Garage. Todos los derechos reservados."
};

export const heroContent = {
  title: "Tu Jeep Wrangler\nLlave en Mano",
  subtitle: "Importamos tu Jeep Wrangler desde EAU a España.\nHomologación y matriculación en España incluidas.",
  ctaText: "Solicitar Presupuesto"
};

export const services = [
  {
    id: 1,
    icon: "search",
    title: "Búsqueda Personalizada",
    description: "Encontramos el Jeep Wrangler perfecto ajustado a tu presupuesto y preferencias"
  },
  {
    id: 2,
    icon: "clipboard",
    title: "Informe Independiente",
    description: "Revisión exhaustiva del vehículo con informe detallado antes de la compra"
  },
  {
    id: 3,
    icon: "truck",
    title: "Transporte Asegurado",
    description: "Transporte asegurado desde origen hasta tu domicilio"
  },
  {
    id: 4,
    icon: "filecheck",
    title: "Homologación y Matriculación",
    description: "Gestionamos toda la documentación y trámites para circular en España"
  }
];

export const steps = [
  {
    id: 1,
    title: "Cuéntanos tu Ideal",
    description: "Comparte tus preferencias: modelo, año, color, equipamiento y presupuesto."
  },
  {
    id: 2,
    title: "Búsqueda y Verificación",
    description: "Localizamos opciones y realizamos inspección profesional con informe detallado."
  },
  {
    id: 3,
    title: "Importación Segura",
    description: "Gestionamos la compra, transporte asegurado y todos los trámites aduaneros."
  },
  {
    id: 4,
    title: "Llave en Mano",
    description: "Homologación, matriculación y entrega: tu Jeep listo para circular en España."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1506015391300-4802dc74de2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxKZWVwJTIwV3JhbmdsZXJ8ZW58MHx8fHwxNzc2MTcxNjU4fDA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Jeep Wrangler en desierto"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1640021042546-2a1b900f324b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxKZWVwJTIwV3JhbmdsZXJ8ZW58MHx8fHwxNzc2MTcxNjU4fDA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Jeep Wrangler blanco"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1595392004747-3d9b64a4b013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxKZWVwJTIwV3JhbmdsZXJ8ZW58MHx8fHwxNzc2MTcxNjU4fDA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Jeep Wrangler negro en ciudad"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/17722340/pexels-photo-17722340.jpeg?w=800",
    alt: "Jeep Wrangler todoterreno"
  }
];

export const stats = [
  {
    id: 1,
    icon: "award",
    value: "5+ Años",
    label: "de experiencia importando"
  },
  {
    id: 2,
    icon: "car",
    value: "200+",
    label: "vehículos importados"
  },
  {
    id: 3,
    icon: "smile",
    value: "95%",
    label: "clientes satisfechos"
  },
  {
    id: 4,
    icon: "globe",
    value: "Desde EAU",
    label: "importamos desde Emiratos Árabes"
  }
];

export const contactFormFields = [
  { id: "nombre", label: "Nombre *", placeholder: "Tu nombre completo", type: "text", required: true },
  { id: "email", label: "Email *", placeholder: "tu@email.com", type: "email", required: true },
  { id: "telefono", label: "Teléfono *", placeholder: "+34 666 66 66", type: "tel", required: true },
  { id: "presupuesto", label: "Presupuesto Aproximado", placeholder: "Ej: 30.000€ - 40.000€", type: "text", required: false }
];
